import NoRights from "../Common/NoRights";
import React, { useState, useEffect, Fragment, useRef } from "react";
import { AsyncAjaxGet, AsyncAjaxPost, } from "../Common/AsyncAjaxService";
import { utils, ResponseCode, MobileCallbackTypes } from "../../utils/Utils";
import Loader from "../Common/Loader";
import { useSelector } from 'react-redux'
import '../Zenswipe/zenswipe.js';
import { useDispatch } from 'react-redux'
import useGenerateToken from "components/Hook/useGenerateToken";
import ReactDom, { unmountComponentAtNode } from "react-dom";
import VGPopUp from "components/Controls/VGPopUp";
import './Plancheckout.scss'
import useSession from "components/Hook/useSession";

const PlanCheckout = (props) => {

    const { BusinessID, ReactBusinessId, ReactUserID, UserID, CurrencySymbol, WebsiteBuilderParentWebsite, IsModifyAllowed, NewCustomizedWebsitePrice, CountryID, AmplitudeBusinessID, BuildInDomain, VagaroURL } = useSelector((state) => state.Business);
    const dispatch = useDispatch();

    const VagaroAPIEnum = {
        GetVSitePlan: "merchants/" + BusinessID + "/vsiteplan",
        ProductPurchase: "merchants/" + BusinessID + "/vsiteplan/savepurchaseproduct",
        GetOwnerCardDetails: BusinessID + "/zenswipe/getownercarddetails",
        CollectPayment: BusinessID + "/zenswipe/collectdomainpayment",
        UpdateOwnerCardDetails: BusinessID + "/zenswipe/updateownercarddetails",
        AddLogInAmplitude: "amplitude/addloginamplitude"
    };

    const [isLoading, setLoading] = useState(false);
    const [planData, setPlanData] = useState([]);
    const [totalamount, setTotalAmount] = useState(0);
    const [taxamount, setTaxAmount] = useState(0);
    const [isFinish, setFinish] = useState(false);
    const [paymentSucess, setpaymentSucess] = useState(false);
    const [showcc, setshowcc] = useState(false);
    const [showvagarobugs, setshowvagarobugs] = useState(false);
    const [subtotal, setsubtotal] = useState(0);
    const cardTokenDetails = useRef([]);
    const zenswipeTransaction = useRef("");
    const [isExistingCard, setisExistingCard] = useState(true);
    const [acknowledge, setacknowledge] = useState(false);
    const [vagarobugs, setvagarobugs] = useState(0);

    const VagaroCredit = useRef(0);
    const Totalamout = useRef(0);
    const ccamout = useRef(0);
    const [vagarobugsval, setvagarobugsval] = useState(0);


    const elementRefs = useRef({
        acknowledgeText: null,
        bugs: null
    });


    const CheckSession = async () => {
        setLoading(true);
        return await useSession(dispatch, BusinessID, UserID, (data) => {
            setLoading(false);
            if (data == true) {
                if (!utils.IsFromProApp()) {
                    utils.SetPageTitle("Plan Checkout");
                }
                if (ReactBusinessId > 0) {
                    GetOwnerCard();
                }
                CheckLogin();
            }
        });
    }

    useEffect(() => {
        CheckSession()
    }, [BusinessID]);

    useEffect(() => {
        if (isFinish) {
            window.setTimeout(() => {
                setFinish(false);
                setLoading(false);
            }, 3000)
        }
    }, [isFinish])


    const CheckLogin = () => {
        if (ReactBusinessId === -2) {
            window.location.replace(WebsiteBuilderParentWebsite + "login");
        }
    }
    const GetVSitePlanByID = async (PlanID, IsIFrameLoad) => {
        const access_token = await useGenerateToken(dispatch);
        if (utils.Validate(access_token)) {
            setLoading(true);
            await AsyncAjaxGet(
                VagaroAPIEnum.GetVSitePlan + "/" + PlanID + "?CountryID=" + CountryID,
                access_token,
                function onSuccess(data) {
                    try {
                        if (data != null && data.data != null && data.data.responseCode == ResponseCode.Success) {
                            if (data != null && data.data != null && data.data.data != null) {
                                if (utils.IsFromProApp()) {
                                    utils.CallBackGivenToMobileApp(MobileCallbackTypes.TitleWithBack, " ", 1, 65);
                                }
                                var PlanData = data.data.data;
                                if (PlanData.isPurchased) {
                                    setPlanData(PlanData);
                                    setpaymentSucess(true);
                                    setLoading(false);
                                    return;
                                } else {
                                    setPlanData(data.data.data);
                                    var total = 0;
                                    var taxcalc = 0;
                                    var totalpayment = 0;
                                    total = total + parseFloat(PlanData.sellPrice);
                                    taxcalc = PlanData.tax;
                                    totalpayment = total + taxcalc;
                                    setTaxAmount(taxcalc);
                                    setTotalAmount(totalpayment);
                                    ccamout.current = totalpayment;
                                    Totalamout.current = totalpayment;
                                    setvagarobugs(PlanData.vagaroCredit);
                                    setsubtotal(total);
                                    setLoading(false);
                                    if (IsIFrameLoad) {
                                        GetCCIframe();
                                    }
                                }
                            }
                            else {
                                setLoading(false);
                            }
                        }
                        else {
                            setLoading(false);
                        }
                    }
                    catch (error) {
                        setLoading(false);
                        utils.appInsightTrack(
                            ReactBusinessId,
                            ReactUserID,
                            "Get Plan Details By Id",
                            null,
                            ""
                        );
                        utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                    }
                },
                function OnError() {
                    setLoading(false);
                    utils.appInsightTrack(
                        ReactBusinessId,
                        ReactUserID,
                        "Get Plan Details By Id",
                        null,
                        ""
                    );
                    utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                }
            );
        }
        else {
            utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
        }
    }

    const GetOwnerCard = async () => {
        const access_token = await useGenerateToken(dispatch);
        if (utils.Validate(access_token)) {
            setLoading(true);
            await AsyncAjaxPost(
                VagaroAPIEnum.GetOwnerCardDetails,
                null,
                access_token,
                function onSuccess(data) {
                    try {
                        if (data != null && data.data != null && data.data.responseCode == ResponseCode.Success) {
                            if (data != null && data.data != null && data.data.data != null) {
                                cardTokenDetails.current = data.data.data;
                                let isIFrameLoad = false;
                                if (!utils.Validate(cardTokenDetails.current.cardTokenID)) {
                                    isIFrameLoad = true;
                                }
                                else {
                                    isIFrameLoad = false;
                                }
                                if (props.PlanID !== undefined && props.PlanID !== null && props.PlanID !== "") {
                                    GetVSitePlanByID(props.PlanID, isIFrameLoad);
                                }
                            }
                            else {
                                setLoading(false);
                                cardTokenDetails.current = [];
                            }
                        }
                        else {
                            setLoading(false);
                            cardTokenDetails.current = [];
                        }
                    }
                    catch (error) {
                        setLoading(false);
                        cardTokenDetails.current = [];
                        utils.appInsightTrack(
                            ReactBusinessId,
                            ReactUserID,
                            "Get Owner Card",
                            null,
                            ""
                        );
                    }
                },
                function OnError() {
                    setLoading(false);
                    cardTokenDetails.current = [];
                    utils.appInsightTrack(
                        ReactBusinessId,
                        ReactUserID,
                        "Get Owner Card",
                        null,
                        ""
                    );
                }
            );
        }
        else {
            utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
        }
    }


    const FormatPrice = (value) => {
        return (
            value.toLocaleString(undefined, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
            })
        );
    };

    const ShowLoadingPanel = (FlgShow) => {
        setLoading(FlgShow);
    }

    const GetCCIframe = async () => {
        const access_token = await useGenerateToken(dispatch);
        if (utils.Validate(access_token) && (typeof cardTokenDetails.current != 'undefined' && cardTokenDetails.current != null && cardTokenDetails.current.merchantTokenID != null && cardTokenDetails.current.merchantTokenID != "")) {
            setLoading(true);
            setshowcc(true);
            window.vui.loader = ShowLoadingPanel;
            window.vui.getTypeWithoutButtonAndAuthorization("dvccframe", 420, cardTokenDetails.current.merchantTokenID, 470, '', 1, 'React Plan Purchase', true, "0", "", access_token, BusinessID);
        }
        else {
            utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
        }
    };

    const ProductPurchase = async () => {
        const access_token = await useGenerateToken(dispatch);
        if (!IsModifyAllowed) {
            utils.ShowAlert("Message", "Sorry, You don't have permission to purchase Plan.", "OpenDialog");
        }
        else {
            if (utils.Validate(access_token)) {
                setLoading(true);
                const Requestdata = {};
                Requestdata.UserID = UserID;
                Requestdata.CountryID = CountryID;
                Requestdata.CCNo = ccamout.current > 0 ? cardTokenDetails.current.creditCardNumber : "";
                Requestdata.CCType = ccamout.current > 0 ? cardTokenDetails.current.creditCardType : "";
                Requestdata.OriginalAmount = planData.sellPrice;
                Requestdata.TotalAmount = ccamout.current;
                Requestdata.CCAmount = ccamout.current;
                Requestdata.TotalVagaroCredit = VagaroCredit.current;
                Requestdata.Tax = planData.tax;
                Requestdata.InventoryID = planData.encVagaroProductID;
                Requestdata.MerchantTokenID = cardTokenDetails.current.merchantTokenID;
                Requestdata.CurrencyCode = cardTokenDetails.current.currencyCode;
                Requestdata.CurrencySymbol = CurrencySymbol;
                Requestdata.TransactionID = zenswipeTransaction.current;
                await AsyncAjaxPost(
                    VagaroAPIEnum.ProductPurchase,
                    Requestdata,
                    access_token,
                    function onSuccess(data) {
                        try {
                            if (data != null && data.data != null && data.data.responseCode == ResponseCode.Success) {
                                setFinish(true);
                                setpaymentSucess(true)
                            }
                        }
                        catch (error) {
                            setFinish(false);
                            utils.appInsightTrack(
                                ReactBusinessId,
                                ReactUserID,
                                "Plan Purchase Process",
                                "Purchase Plan",
                                ""
                            );
                        }
                    },
                    function OnError(error) {
                        setFinish(false);
                    }
                );

            }
            else {
                utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
            }
        }
    }

    const UpdateOwnerCardDetails = async (ZenswipeResponse) => {
        const access_token = await useGenerateToken(dispatch);
        if (utils.Validate(access_token)) {
            setLoading(true);
            const Requestdata = {};
            Requestdata.CardTokenID = ZenswipeResponse.card_token;
            Requestdata.CVV = ZenswipeResponse.cvv;
            Requestdata.CCFirstName = ZenswipeResponse.first_name;
            Requestdata.CCLastName = ZenswipeResponse.last_name;
            Requestdata.CreditCardType = ZenswipeResponse.cc_type;
            Requestdata.CreditCardNumber = ZenswipeResponse.cc_no;
            await AsyncAjaxPost(
                VagaroAPIEnum.UpdateOwnerCardDetails,
                Requestdata,
                access_token,
                function onSuccess(data) {
                    if (data != null && data.data != null && data.data.responseCode == ResponseCode.Success) {
                        if (data != null && data.data != null && data.data.data != null && data.data.data === true) {
                            try {
                                let CardToken = [];
                                CardToken.lBusinessID = ReactBusinessId;
                                CardToken.cardTokenID = ZenswipeResponse.card_token;
                                CardToken.cvv = ZenswipeResponse.cvv;
                                CardToken.amount = ccamout.current;
                                CardToken.currencyCode = cardTokenDetails.current.currencyCode;
                                CardToken.currencySymbol = CurrencySymbol;
                                CardToken.merchantTokenID = cardTokenDetails.current.merchantTokenID;
                                CardToken.creditCardNumber = Requestdata.CreditCardNumber;
                                CardToken.creditCardType = Requestdata.CreditCardType;
                                cardTokenDetails.current = CardToken;
                                DoPayment(false);
                            }
                            catch (error) {
                                setLoading(false);
                                utils.appInsightTrack(
                                    ReactBusinessId,
                                    ReactUserID,
                                    "Update Card Details",
                                    ReactBusinessId,
                                    ""
                                );
                            }
                        }
                        else {
                            setLoading(false);
                        }
                    }
                    else {
                        setLoading(false);
                    }
                },
                function OnError(error) {
                    setLoading(false);
                    if (error != undefined && error.response != undefined && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors.exception != undefined) {
                        utils.appInsightTrack(
                            ReactBusinessId,
                            ReactUserID,
                            "Update Card Details",
                            ReactBusinessId,
                            ""
                        );
                        utils.ShowAlert("Warning", error.response.data.errors.exception, "OpenDialog");
                    }
                }
            );
        }
        else {
            utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
        }
    }

    window.onGetTokenCallback = (res) => {

        if (res.data.custom_code == ResponseCode.Success) {
            setLoading(true);
            if (utils.Validate(res.data.data) && res.data.data.save_card === false) {
                if (utils.Validate(res.data.data.card_token) && utils.Validate(res.data.data.cvv) && totalamount > 0
                    && utils.Validate(cardTokenDetails.current.currencyCode) && utils.Validate(cardTokenDetails.current.merchantTokenID)) {
                    let CardToken = [];
                    CardToken.lBusinessID = ReactBusinessId;
                    CardToken.cardTokenID = res.data.data.card_token;
                    CardToken.cvv = res.data.data.cvv;
                    CardToken.amount = ccamout.current;
                    CardToken.currencyCode = cardTokenDetails.current.currencyCode;
                    CardToken.currencySymbol = CurrencySymbol;
                    CardToken.merchantTokenID = cardTokenDetails.current.merchantTokenID;
                    CardToken.creditCardNumber = res.data.data.cc_no;
                    CardToken.creditCardType = res.data.data.cc_type;
                    cardTokenDetails.current = CardToken;
                    DoPayment(false);
                }
                else {
                    setLoading(false);
                }
            }
            else {
                setLoading(true);
                if (utils.Validate(res.data.data) && res.data.data.save_card === true) {
                    UpdateOwnerCardDetails(res.data.data);
                }
            }
        }
        else {
            setLoading(false);
            if (utils.Validate(res.data.Message)) {
                utils.ShowAlert("Alert", res.data.Message, "OpenDialog1");
            }
        }
    }

    window.onRequiredCallback = (res) => {
        if (res.eventType === "required") {
            setLoading(false);
        }
    }

    const DoPayment = async (ischecked) => {
        const access_token = await useGenerateToken(dispatch);
        if (ccamout.current == 0) {
            ProductPurchase();
            return;
        }
        else {
            if (utils.Validate(access_token)) {
                if (utils.Validate(planData)) {
                    if (showcc && ischecked) {
                        window.vui.frame.zenswipe.submit();
                        setLoading(false);
                        return;
                    }
                    setLoading(true);
                    const Requestdata = {};
                    Requestdata.cardTokenId = cardTokenDetails.current.cardTokenID;
                    Requestdata.cvv = cardTokenDetails.current.cvv;
                    Requestdata.amount = ccamout.current;
                    Requestdata.currencyCode = cardTokenDetails.current.currencyCode;
                    Requestdata.currencySymbol = CurrencySymbol;
                    Requestdata.merchant_token_id = cardTokenDetails.current.merchantTokenID;
                    await AsyncAjaxPost(
                        VagaroAPIEnum.CollectPayment,
                        Requestdata,
                        access_token,
                        function onSuccess(data) {
                            try {
                                if (data != null && data.data != null && data.data.CustomCode == ResponseCode.Success) {
                                    if (data != null && data.data != null && data.data.Data.customCode == ResponseCode.Success) {
                                        zenswipeTransaction.current = data.data.Data.transactionID;
                                        if (utils.Validate(zenswipeTransaction.current)) {
                                            ProductPurchase();
                                        }
                                        else {
                                            setLoading(false);
                                            utils.ShowAlert("Alert", "Sorry, Your payment has been failed.", "OpenDialog");
                                        }
                                    }
                                    else {
                                        setLoading(false);
                                        utils.ShowAlert("Alert", data.data.Data.message, "OpenDialog");
                                    }
                                }
                                else {
                                    setLoading(false);
                                    utils.ShowAlert("Alert", "Sorry, Your payment has been failed.", "OpenDialog");
                                }
                            } catch (error) {
                                setLoading(false);
                                utils.appInsightTrack(
                                    ReactBusinessId,
                                    ReactUserID,
                                    "Validate Do Payment for Purchased Plan",
                                    Requestdata,
                                    ""
                                );
                            }
                        },
                        function OnError() {
                            setLoading(false);
                            utils.appInsightTrack(
                                ReactBusinessId,
                                ReactUserID,
                                "Validate Do Payment for Purchased Plan",
                                Requestdata,
                                ""
                            );
                        }
                    );
                }
            }
            else {
                utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
            }
        }
    }

    const ValidatePurchasePlan = async () => {
        const access_token = await useGenerateToken(dispatch);
        if (!acknowledge) {
            elementRefs.current["acknowledgeText"].style.color = 'red';
            return "";
        }
        else {
            elementRefs.current["acknowledgeText"].style.color = '';
        }
        setLoading(true);
        if (!IsModifyAllowed) {
            utils.ShowAlert("Message", "Sorry, You don't have permission to purchase plan", "OpenDialog");
        }
        else {
            if (utils.Validate(access_token)) {
                if (utils.Validate(planData)) {
                    var logobject = {};
                    logobject.PageURL = window.location.href;
                    logobject.Step = 30;
                    logobject.UserAgent = (navigator.userAgent).toLowerCase();
                    logobject.UserID = ReactUserID;
                    logobject.BusinessID = AmplitudeBusinessID;
                    logobject.MySiteURL = BuildInDomain + "/" + VagaroURL;
                    logobject.CountryID = CountryID;
                    await AddLogInAmplitude(logobject);
                    DoPayment(true);
                }
                else {
                    setLoading(false);
                }
            }
            else {
                setLoading(false);
                utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
            }
        }
    }

    const AddLogInAmplitude = async (logobject) => {
        const access_token = await useGenerateToken(dispatch);
        setLoading(true);
        const Requestdata = {};
        Requestdata.PageURL = logobject.PageURL;
        Requestdata.Step = logobject.Step;
        Requestdata.UserAgent = logobject.UserAgent;
        Requestdata.UserID = logobject.UserID;
        Requestdata.BusinessID = logobject.BusinessID;
        Requestdata.MySiteURL = logobject.MySiteURL;
        Requestdata.CountryID = logobject.CountryID;
        await AsyncAjaxPost(
            VagaroAPIEnum.AddLogInAmplitude,
            Requestdata,
            access_token,
            function onSuccess(data) {
                try {
                    if (data != null && data.data != null && data.data.data != null) {
                        setLoading(false);
                    }
                    else {
                        setLoading(false);
                    }
                } catch (error) {
                    console.log("error");
                    setLoading(false);
                }
            },
            function OnError() {
                console.log("error");
            }
        );
    }

    const ExistingCardSelection = async () => {
        if (!isExistingCard) {
            setshowcc(false);
            setisExistingCard(true);
        }
    }

    const NewCardSelection = async () => {
        if (isExistingCard) {
            setshowcc(true);
            setisExistingCard(false);
            GetCCIframe();
        }
    }


    const CheckShowVagaroBugs = () => {
        setshowvagarobugs(!showvagarobugs);
        setvagarobugsval(totalamount > vagarobugs ? FormatPrice(vagarobugs) : FormatPrice(totalamount));
        if (!showvagarobugs) {
            BugsonBlur(totalamount > vagarobugs ? vagarobugs : totalamount);
        }
        else {
            ccamout.current = totalamount;
        }
    }

    const BugsonClick = (event) => {
        let qInt = parseFloat(event.target.value);
        let maxbugqtn = totalamount > vagarobugs ? FormatPrice(vagarobugs) : FormatPrice(totalamount)
        if (qInt > maxbugqtn) {
            event.target.value = maxbugqtn;
            return;
        }
        if (qInt <= 0) {
            event.target.value = 0;
            return;
        }
        event.target.value = qInt
    }


    const BugsonBlur = (amount) => {
        if ((amount == undefined || amount == null || amount == "")) {
            VagaroCredit.current = 0;
            setvagarobugsval(0);
            ccamout.current = totalamount;
            return;
        }
        let inputvalue = parseFloat(amount);
        if (Totalamout.current < inputvalue) {
            ExistingCardSelection()
            amount = totalamount > vagarobugs ? FormatPrice(vagarobugs) : FormatPrice(totalamount);
            VagaroCredit.current = totalamount;
            ccamout.current = 0;

        } else if (inputvalue == Totalamout.current) {
            ExistingCardSelection()
            VagaroCredit.current = inputvalue;
            ccamout.current = 0;

        } else if (Totalamout.current > inputvalue) {
            ccamout.current = Totalamout.current - inputvalue;
            VagaroCredit.current = inputvalue;
        }
        else {
            VagaroCredit.current = inputvalue;
            ccamout.current = Totalamout.current;
        }
        amount = parseFloat(amount).toFixed(2);
        setvagarobugsval(amount);
    }

    const SucessCheckout = (prop) => {
        const [contentloading, setContentLoading] = useState(false);
        const iFramstyle = {
            alignItems: "center",
            color: "#5d5e5e",
            display: "flex",
            flexFlow: "column",
            fontSize: "29px",
            gap: "45px",
            justifyContent: "center",
            lineHeight: 1,
            padding: "0px 0px",
            position: "relative",
            textAlign: "center"

        }

        const LoadIfram = () => {
            setContentLoading(true);
        }

        if (utils.IsFromProApp()) {
            utils.CallBackGivenToMobileApp(MobileCallbackTypes.TitleWithBack, " ", 1, 66);
        }

        const AllreadySechdual = () => {
            return ReactDom.render(
                <VGPopUp
                    id={"allreadysechdual"}
                    onHide={handlepopupClose}
                    title={PopupTitle()}
                    show={true}
                    isRemoveTabModalIndex={true}
                    isShowFooter={true}
                    dialogClassName="cancelauto-renew-alert app-alert-model"
                    body={<div>You have aready scheduled.</div>}
                    footer={<><button className="w-button w-button-primary" onClick={() => { handlepopupClose() }}>OK</button></>}
                />, document.getElementById("OpenDialog")
            )
        }

        const PopupTitle = () => {
            return "Alert";
        }

        const handlepopupClose = () => {
            unmountComponentAtNode(document.getElementById("OpenDialog"));
        }

        const openMigrationPage = (url) => {
            if (utils.IsFromProApp()) {
                utils.CallBackGivenToMobileApp(MobileCallbackTypes.MobileLink, url);
            } else {
                window.open(url, '_blank', 'noreferrer');
            }
        };

        const AddLogDesignInAmplitude = async () => {
            const access_token = await useGenerateToken(dispatch);
            const Requestdata = {};
            Requestdata.PageURL = window.location.href;
            Requestdata.Step = 31;
            Requestdata.UserAgent = (navigator.userAgent).toLowerCase();
            Requestdata.UserID = ReactUserID;
            Requestdata.BusinessID = AmplitudeBusinessID;
            Requestdata.MySiteURL = BuildInDomain + "/" + VagaroURL;
            Requestdata.CountryID = CountryID;
            await AsyncAjaxPost(
                VagaroAPIEnum.AddLogInAmplitude,
                Requestdata,
                access_token,
                function onSuccess(data) {
                    try {
                        if (data != null && data.data != null && data.data.data != null) {
                        }
                        else {
                        }
                    } catch (error) {
                        console.log("error");
                    }
                },
                function OnError() {
                    console.log("error");
                }
            );
        }

        return (
            <div>
                {contentloading && <Loader />}
                <Fragment>
                    <div className="plan-checkout-successful">
                        <div className="plan-checkout-migrate">
                            <div>
                                <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M62 31C62 48.125 48 62 31 62C13.875 62 0 48.125 0 31C0 14 13.875 0 31 0C48 0 62 14 62 31ZM27.375 47.5L50.375 24.5C51.125 23.75 51.125 22.375 50.375 21.625L47.5 18.875C46.75 18 45.5 18 44.75 18.875L26 37.625L17.125 28.875C16.375 28 15.125 28 14.375 28.875L11.5 31.625C10.75 32.375 10.75 33.75 11.5 34.5L24.5 47.5C25.25 48.25 26.625 48.25 27.375 47.5Z" fill="#3E8438" />
                                </svg>
                            </div>
                            <div className="plan-checkout-title">Successful Checkout</div>
                            {prop.Type && prop.Type == 1 ?
                                <Fragment>
                                    <div style={{ fontSize: "initial" }}> Complete the form to start collaborating to build your website with our Design Team.</div>
                                    <button className="w-button w-button-primary" onClick={() => openMigrationPage('https://vagaro.typeform.com/MySiteIntake')}>Migrate Your Site</button>
                                </Fragment>
                                :
                                <Fragment>
                                    <div style={{ fontSize: "initial" }}>Complete the form to start collaborating to build your website with our Design Team.</div>
                                    <button className="w-button w-button-primary" onClick={() => openMigrationPage('https://vagaro.typeform.com/MySiteIntake')}>Collaborate with Design Team</button>
                                </Fragment>
                            }
                        </div>
                    </div>
                </Fragment>
            </div>
        );
    }


    return (
        <Fragment>
            {isLoading && <Loader />}
            <div className={ReactBusinessId <= 0 ? "all-content-container no-access-main-content-wrapper" : (!paymentSucess ? "all-content-container main-content-wrapper" : "")}>
                {(() => {
                    if (ReactBusinessId === 0 || typeof ReactBusinessId === 'undefined') {
                        return (
                            <Fragment>
                                <NoRights />
                            </Fragment>
                        )
                    } else if (!paymentSucess) {
                        return (
                            ReactBusinessId > 0 && (typeof cardTokenDetails.current != 'undefined' && cardTokenDetails.current != null && cardTokenDetails.current.merchantTokenID != null && cardTokenDetails.current.merchantTokenID != "") &&
                            <Fragment>
                                <div className="page-root page-plancheckout">
                                    <div className="page-content checkout-page-content">
                                        <div className="plan-checkout-wrapper">
                                            {utils.Validate(planData) &&
                                                <Fragment>
                                                    <div className="right-part-checkout-items">
                                                        <div className="plan-checkout-items">
                                                            <div className="plan-section-title">
                                                                Order Details
                                                            </div>
                                                            <Fragment>
                                                                <div className="plan-checkout-item">
                                                                    <div className="item-desc">
                                                                        <span className="name custom-site-title">
                                                                            Custom Website
                                                                        </span>
                                                                        <span className="expiry">
                                                                            {planData.productName}
                                                                        </span>
                                                                    </div>
                                                                    <div className="item-price custom-website-price">
                                                                        <div className="price-through"><del>{planData.wbAmount > 0 && CurrencySymbol + FormatPrice(planData.wbAmount)}</del></div>
                                                                        {CurrencySymbol + FormatPrice(planData.sellPrice)}
                                                                    </div>
                                                                </div>

                                                            </Fragment>

                                                            <div className="plan-checkout-item subtotal-row">
                                                                <div className="subtotal-row-item">
                                                                    <div className="item-desc tax-row">
                                                                        <span className="name">
                                                                            Subtotal
                                                                        </span>
                                                                    </div>
                                                                    <div className="item-price tax-price-editor">
                                                                        {CurrencySymbol}{FormatPrice(subtotal)}
                                                                    </div>
                                                                </div>
                                                                <div className={!showvagarobugs ? "subtotal-row-item tax-border-down" : "subtotal-row-item"}>
                                                                    <div className="item-desc tax-row">
                                                                        <span className="name">
                                                                            Tax
                                                                        </span>
                                                                    </div>
                                                                    <div className="item-price tax-price-editor">
                                                                        {CurrencySymbol}{FormatPrice(taxamount)}
                                                                    </div>
                                                                </div>
                                                                {showvagarobugs && vagarobugs > 0 && planData.sellPrice > 0 &&
                                                                    <div className="subtotal-row-item tax-border-down">
                                                                        <div className="item-desc tax-row">
                                                                            <span className="name">
                                                                                Vagaro Bucks
                                                                            </span>
                                                                        </div>
                                                                        <div className="item-price tax-price-editor">
                                                                            -{CurrencySymbol}{FormatPrice(vagarobugsval)}
                                                                        </div>
                                                                    </div>
                                                                }
                                                                <div className="subtotal-row-item">
                                                                    <div className="item-desc">
                                                                        <span className="name">
                                                                            Total
                                                                        </span>
                                                                    </div>
                                                                    <div className="item-price">
                                                                        {CurrencySymbol}{FormatPrice(ccamout.current)}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="left-part-checkout-items">
                                                        <div className="plan-payment-wrapper">
                                                            <div className="plan-section-title py-t16 checkout-tlt">
                                                                Checkout
                                                            </div>
                                                            {typeof cardTokenDetails.current.cardTokenID != 'undefined' && cardTokenDetails.current.cardTokenID != null && cardTokenDetails.current.cardTokenID != "" && planData.sellPrice > 0 &&
                                                                <Fragment>
                                                                    <div className="plan-section-title">
                                                                        Payment Details
                                                                    </div>
                                                                    <div className="plan-saved-payment">
                                                                        <div className="plan-saved-payment-items">
                                                                            <a href={false}
                                                                                className={!showcc ? "plan-saved-payment-item item-selected" : "plan-saved-payment-item"}
                                                                                onClick={() => ExistingCardSelection()}
                                                                            >{cardTokenDetails.current.creditCardType} ending in {cardTokenDetails.current.creditCardNumber}
                                                                            </a>
                                                                            {
                                                                                vagarobugs > 0 && planData.sellPrice > 0 &&
                                                                                <a href={false}
                                                                                    className={showvagarobugs ? "plan-saved-payment-item item-selected" : "plan-saved-payment-item"}
                                                                                    onClick={() => CheckShowVagaroBugs()}>Vagaro Bucks</a>
                                                                            }
                                                                            <a href={false}
                                                                                className={showcc ? "plan-saved-payment-item item-selected" : "plan-saved-payment-item"}
                                                                                onClick={(e) => NewCardSelection()}>
                                                                                New Payment Method
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </Fragment>
                                                            }
                                                            {showcc &&
                                                                <div className="iframe-container-plan-checkout">
                                                                    <div id="dvccframe"></div>
                                                                </div>
                                                            }
                                                            {showvagarobugs && vagarobugs > 0 && planData.sellPrice > 0 &&
                                                                <div className="border-down plan-border-none">
                                                                    <div className="plan-bucks-details">
                                                                        <Fragment>
                                                                            <div className="plan-section-title">
                                                                                Vagaro Bucks
                                                                            </div>
                                                                            <p className="plan-bucks-heading">Used Vagaro Bucks:</p>
                                                                            <div class="vagaro-buck-field">
                                                                                <div className="dollor-sigh">
                                                                                    <span>{CurrencySymbol}</span>
                                                                                    <input maxLength="8" type="number" defaultValue={totalamount > vagarobugs ? FormatPrice(vagarobugs) : FormatPrice(totalamount)} onChange={(e) => BugsonClick(e)} onClick={(e) => BugsonClick(e)} onBlur={(e) => BugsonBlur(e.target.value)} title="Enter vagaro bucks."></input>
                                                                                </div>
                                                                                <label> {" "}of {" "}{CurrencySymbol}{FormatPrice(vagarobugs)}</label>
                                                                            </div>
                                                                        </Fragment>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                        <div className="plan-checkbox-custom-black">
                                                            <input className="form-check-input plan-check-input" type="checkbox" id="missedcheck" value={acknowledge} onClick={() => { setacknowledge(!acknowledge); }} />
                                                            <label className="plan-check-label" for="missedcheck">
                                                                <p ref={(el) => (elementRefs.current.acknowledgeText = el)}>I agree to pay {CurrencySymbol + FormatPrice(totalamount)} today for the design and production of my custom website, and {CurrencySymbol + FormatPrice(NewCustomizedWebsitePrice)} per month for use of the website builder once the website is live, for use of, under license, of my own website.</p>
                                                            </label>
                                                            <label>
                                                                <p>I acknowledge that if I use a custom domain, I am responsible for purchasing and connecting the domain for the website.</p>
                                                                <p>I acknowledge that this purchase is no longer eligible for a refund after the first proof has been sent.</p>
                                                                <p>By clicking ‘Buy Now’, I understand that completion and the use of the website is dependent on my participation and timely response to requests. Failure to respond in a timely manner will result in delay of project completion and ultimately hinder the publishing and use of my website.</p>
                                                            </label>
                                                        </div>

                                                        <div className="plan-actions plan-payment-actions">
                                                            {!(utils.IsFromProApp()) &&
                                                                <a href={false} className="w-button w-button-default" onClick={() => { props.Gotocheckout(false) }}>Back</a>
                                                            }
                                                            <a href={false} onClick={(e) => { ValidatePurchasePlan() }} className="w-button w-button-primary">Buy Now</a>
                                                        </div>
                                                    </div>
                                                </Fragment>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Fragment>
                        )
                    }
                    else {
                        if (!isLoading) {
                            return (
                                <Fragment>
                                    {/* Type={planData.wbAmount > 0 ? 2 : 1} */}
                                    <SucessCheckout Type={props.plan.isOpenSchedulePage ? 2 : 1} />
                                </Fragment>
                            )
                        }
                    }
                })()}
            </div >
        </Fragment >
    );
};

export default PlanCheckout;
